
















































import Vue from 'vue'
import { FinalSettlementPositiveDto } from '@/Application/Expediente'

export default Vue.extend({
  name: 'FinalSettlementPositive',
  props: {
    positivo: {
      type: FinalSettlementPositiveDto || null,
      required: false
    }
  },
  computed: {
    participacionPropiedad (): string {
      if (this.positivo === null) {
        return ''
      }
      return this.positivo.participacionPropiedad.toLocaleString('es-ES', { maximumFractionDigits: 4 })
    },
    participacionAdministracion (): string {
      if (this.positivo === null) {
        return ''
      }
      return this.positivo.participacionAdministracion.toLocaleString('es-ES', { maximumFractionDigits: 4 })
    },
    dataIngresoAdxudicatario (): string {
      if (this.positivo === null) {
        return '-'
      }
      return this.ensureValue(this.positivo.dataIngresoAdxudicatario)
    },
    dataIngresoIvePropiedade (): string {
      if (this.positivo === null) {
        return '-'
      }
      return this.ensureValue(this.positivo.dataIngresoIvaPropetario)
    }
  },
  methods: {
    ensureValue (value: string): string {
      return !value
        ? '-'
        : value
    }
  }
})
